import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, switchMap, throwError } from 'rxjs';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyDTO } from 'src/app/core/models/system/company/company.dto';
import { CompanyUsageLimitDTO } from 'src/app/core/models/system/company/company-usage-limit.dto';
import { CompanyUsageLimitsService } from 'src/app/core/services/utelize/system/company/company-usage-limits-service';
import { ConfigSystemParams, msSize } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { LimitType } from 'src/app/core/enums';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OrderDTO } from 'src/app/core/models/system/order/order.dto';
import { OrdersService } from 'src/app/core/services/utelize/system/order/orders-service';
import { OrderUsageLimitsDTO } from 'src/app/core/models/system/order/order-usage-limits.dto';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { UserDTO } from 'src/app/core/models/system/user/user.dto';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { WarningModalFormComponent } from '../_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-usage-limits-modal-form',
  templateUrl: './usage-limits-modal-form.component.html',
  styleUrls: ['./usage-limits-modal-form.component.scss']
})

export class UsageLimitsModalFormComponent implements AfterViewInit, OnDestroy {

  @Input() dontShowSubmittedWarning: boolean=false;

  @Output() dataHasBeenSaved        : EventEmitter<OrderUsageLimitsDTO>=new EventEmitter<OrderUsageLimitsDTO>();
  @Output() usageLimitsFormCancelled: EventEmitter<void>               =new EventEmitter<void>();

  @ViewChild('beforeCloseWarningModalForm', { static: false }) beforeCloseWarningModalForm!: WarningModalFormComponent;
  @ViewChild('usageLimitsModalForm',        { static: false }) usageLimitsModalForm!       : TemplateRef<void>;
  @ViewChild('warningModalForm',            { static: false }) warningModalForm!           : WarningModalFormComponent;

  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }

  get hintCurrentSpendLimit () { return this.configSystemService.getValue(ConfigSystemParams.FormUsageLimitsHintCurrentSpendLimit,  "Current Spend Limit"        ); }
  get hintSelfAuthSpendLimit() { return this.configSystemService.getValue(ConfigSystemParams.FormUsageLimitsHintSelfAuthSpendLimit, "Self Authorised Spend Limit"); }
  get hintSpendLimit        () { return this.configSystemService.getValue(ConfigSystemParams.FormUsageLimitsHintSpendLimit,         "Spend Limit"                ); }
  get textCurrentSpendLimit () { return this.configSystemService.getValue(ConfigSystemParams.FormUsageLimitsTextCurrentSpendLimit,  "Current Month Spend Limit"  ); }
  get textSelfAuthSpendLimit() { return this.configSystemService.getValue(ConfigSystemParams.FormUsageLimitsTextSelfAuthSpendLimit, "Self Authorised Spend Limit"); }
  get textSpendLimit        () { return this.configSystemService.getValue(ConfigSystemParams.FormUsageLimitsTextSpendLimit,         "Spend Limit"                ); }

  get showDataLimit             () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUsageLimitsShowDataLimit,              true ); }
  get showHintCurrentSpendLimit () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUsageLimitsShowHintCurrentSpendLimit,  false); }
  get showHintSelfAuthSpendLimit() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUsageLimitsShowHintSelfAuthSpendLimit, false); }
  get showHintSpendLimit        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUsageLimitsShowHintSpendLimit,         false); }
  get showNoLimit               () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUsageLimitsShowNoLimit,                true ); }
  get showSelfAuthSpendLimit    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormUsageLimitsShowSelfAuthSpendLimit,     false); }

  private company                 : CompanyDTO | undefined;
  private companyUsageLimits      : CompanyUsageLimitDTO | undefined;
  private currOrderUsageLimits    : OrderUsageLimitsDTO | undefined;
  private pendingOrderUsageLimits : OrderUsageLimitsDTO | undefined;
  private possibleOrderUsageLimits: OrderUsageLimitsDTO | undefined;
  private sureSimOrder            : OrderDTO | undefined;
  private sureSimOrderId          : number=0;
  private sureSimUser             : UserDTO | undefined;
  private usageLimitsModalFormRef!: NgbModalRef;

  public beforeCloseAnimationLink : string | undefined;
  public companySelfAuthLimit     : number | string="Unknown";
  public companyDataLimit         : number | string="Unknown";
  public companyDataWeightCode    : string="MB";
  public companyUsageLimit        : number | string="Unknown";
  public currentLimitHint         : null | number | undefined;
  public curUser                  : SystemUserDTO;
  public formSubmitted            : boolean=false;
  public formTitle                : string="Manage Limit";
  public LimitType                = LimitType;
  public overrideCurrentMonth     : boolean=false;
  public overrideCurrentMonthData : boolean=false;
  public selectedLimitType        : number=LimitType.Spend;
  public useCustomDataLimit       : boolean=false;
  public useCustomSpendLimit      : boolean=false;
  public usageLimitsForm!         : UntypedFormGroup;

  constructor(
    private authenticationService    : AuthenticationService,
    private companiesService         : CompaniesService,
    private companyUsageLimitsService: CompanyUsageLimitsService,
    private configSystemService      : ConfigSystemService,
    private exceptionsService        : ExceptionsService,
    private formBuilder              : UntypedFormBuilder,
    private lastPassKillerService    : LastPassKillerService,
    private modalService             : NgbModal,
    private ordersService              : OrdersService,
    private usersService               : UsersService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public get companyCurrencySymbol(): string {
    try {
      return this.company?.invoiceCurrencySymbol ?? "£";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "£";
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.formSubmitted          =false;
      this.overrideCurrentMonth   =false;
      this.overrideCurrentMonthData=false;
      this.selectedLimitType      =LimitType.Spend;
      this.useCustomDataLimit     =false;
      this.useCustomSpendLimit    =false;
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(orderID: number, pendingOrderUsageLimits?: OrderUsageLimitsDTO): void {
    try {
      if (orderID==undefined || orderID<=0) {
        throw new Error("UsageLimitsModalFormComponent.openForm() - OrderID cannot be determined");
      }

      this.sureSimOrderId=orderID;

      this.resetMainVariables();
      this.pendingOrderUsageLimits=pendingOrderUsageLimits;
      this.getSureSimOrderAndOpenModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.usageLimitsModalFormRef=this.modalService.open(this.usageLimitsModalForm, { backdrop: this.modalBackGround,
                                                                                       centered: true,
                                                                                       keyboard: false,
                                                                                       size    : msSize.Medium });
    }
    catch(e) {
      this.usageLimitsFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  get formOfUsageLimits() {
    return this.usageLimitsForm.controls;
  }

  private setUpForm(): void {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm(): void {
    try {
      this.removeFormFields(this.usageLimitsForm);

      this.usageLimitsForm=this.formBuilder.group({ });

      this.addFormFields(this.usageLimitsForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormFields(formGroup: UntypedFormGroup): void {
    try {
      if (formGroup==this.usageLimitsForm) {
        this.addFormControl(formGroup, "currentLimit",         "",   []);
        this.addFormControl(formGroup, "dataLimit",            "",   []);
        this.addFormControl(formGroup, "dataLimitCurrent",     "",   []);
        this.addFormControl(formGroup, "dataLimitCurrentUnit", "MB", []);
        this.addFormControl(formGroup, "dataLimitUnit",        "MB", []);
        this.addFormControl(formGroup, "selfAuthLimit",        "",   []);
        this.addFormControl(formGroup, "usageLimit",           "",   []);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators): void {
    try {
      form.addControl(dataField, new FormControl(value, validators));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private removeFormFields(form: UntypedFormGroup): void {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private populateFormFields(formGroup: UntypedFormGroup): void {
    try {
      if (formGroup==this.usageLimitsForm && this.sureSimOrder != undefined) {
        const source=this.pendingOrderUsageLimits ?? this.currOrderUsageLimits;

        this.selectedLimitType=source?.limitType ?? this.sureSimOrder.limitType ?? this.companyUsageLimits?.limitType ?? LimitType.Spend;

        const effectiveDataLimitForOverride     =source?.dataLimit      ?? this.companyDataLimit;
        const effectiveDataWeightCodeForOverride=source?.dataLimitDataWeightCode ?? this.companyDataWeightCode ?? "MB";
        const currentDataWeightCodeForOverride  =source?.dataLimitCurrentDataWeightCode ?? "MB";
        const effectiveSpendLimitForOverride    =source?.limit          ?? this.companyUsageLimits?.limit;

        this.overrideCurrentMonth    =this.selectedLimitType===LimitType.Spend &&
                                      source?.limitCurrent     != null &&
                                      source?.limitCurrent     != undefined &&
                                      source?.limitCurrent     !== effectiveSpendLimitForOverride;
        this.overrideCurrentMonthData=this.selectedLimitType===LimitType.Data &&
                                      source?.dataLimitCurrent != null &&
                                      source?.dataLimitCurrent != undefined &&
                                      (source?.dataLimitCurrent !== effectiveDataLimitForOverride ||
                                       currentDataWeightCodeForOverride !== effectiveDataWeightCodeForOverride);
        this.useCustomDataLimit      =this.selectedLimitType===LimitType.Data &&
                                      (!this.companyDataLimit ||
                                      (source?.dataLimit       != null &&
                                       source?.dataLimit       != undefined &&
                                       source?.dataLimit       !== this.companyDataLimit));
        this.useCustomSpendLimit     =this.selectedLimitType===LimitType.Spend &&
                                      (!this.companyUsageLimit ||
                                      (source?.limit           != null &&
                                       source?.limit           != undefined &&
                                       source?.limit           !== this.companyUsageLimits?.limit));

        this.usageLimitsForm.controls["currentLimit"].setValue(        this.overrideCurrentMonth     ? source?.limitCurrent     : null);
        this.usageLimitsForm.controls["dataLimit"].setValue(           this.useCustomDataLimit       ? source?.dataLimit        : null);
        this.usageLimitsForm.controls["dataLimitCurrent"].setValue(    this.overrideCurrentMonthData ? source?.dataLimitCurrent : null);
        this.usageLimitsForm.controls["dataLimitCurrentUnit"].setValue(source?.dataLimitCurrentDataWeightCode ?? this.sureSimOrder?.orderSpendDTO?.dataLimitDataWeightCode ?? this.companyDataWeightCode ?? "MB");
        this.usageLimitsForm.controls["dataLimitUnit"].setValue(       source?.dataLimitDataWeightCode        ?? this.sureSimOrder?.orderSpendDTO?.dataLimitDataWeightCode ?? this.companyDataWeightCode ?? "MB");
        this.usageLimitsForm.controls["selfAuthLimit"].setValue(       source?.limitSelfAuth);
        this.usageLimitsForm.controls["usageLimit"].setValue(          this.useCustomSpendLimit      ? source?.limit             : null);

        this.updateLimitTypeValidators();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public currentLimitKeyUp(e: any): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onOverrideCurrentMonthDataChange(event: Event): void {
    try {
      this.overrideCurrentMonthData=(event.target as HTMLInputElement).checked;
      if (!this.overrideCurrentMonthData) {
        this.usageLimitsForm.controls["dataLimitCurrent"].setValue(null);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onUseCustomDataLimitChange(event: Event): void {
    try {
      this.useCustomDataLimit=(event.target as HTMLInputElement).checked;
      if (!this.useCustomDataLimit) {
        this.usageLimitsForm.controls["dataLimit"].setValue(null);
      }
      this.updateLimitTypeValidators();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onLimitTypeChange(limitType: number): void {
    try {
      this.selectedLimitType=limitType;
      this.updateLimitTypeValidators();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onOverrideCurrentMonthChange(event: Event): void {
    try {
      this.overrideCurrentMonth=(event.target as HTMLInputElement).checked;
      if (!this.overrideCurrentMonth) {
        this.usageLimitsForm.controls["currentLimit"].setValue(null);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onUseCustomSpendLimitChange(event: Event): void {
    try {
      this.useCustomSpendLimit=(event.target as HTMLInputElement).checked;
      if (!this.useCustomSpendLimit) {
        this.usageLimitsForm.controls["usageLimit"].setValue(null);
      }
      this.updateLimitTypeValidators();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public selectLimitType(limitType: number): void {
    try {
      this.selectedLimitType  =limitType;
      this.useCustomDataLimit =!this.companyDataLimit  && limitType===LimitType.Data;
      this.useCustomSpendLimit=!this.companyUsageLimit && limitType===LimitType.Spend;
      this.usageLimitsForm.controls["dataLimit"].setValue(null);
      this.usageLimitsForm.controls["usageLimit"].setValue(null);
      this.updateLimitTypeValidators();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private updateLimitTypeValidators(): void {
    try {
      const dataLimit  =this.usageLimitsForm.get("dataLimit");
      const usageLimit =this.usageLimitsForm.get("usageLimit");

      const spendRequired=this.selectedLimitType===LimitType.Spend && (this.useCustomSpendLimit || !this.companyUsageLimit);
      const dataRequired =this.selectedLimitType===LimitType.Data  && (this.useCustomDataLimit  || !this.companyDataLimit);

      if (spendRequired) {
        usageLimit?.setValidators([Validators.required]);
        dataLimit?.clearValidators();
      } else if (dataRequired) {
        dataLimit?.setValidators([Validators.required]);
        usageLimit?.clearValidators();
      } else {
        usageLimit?.clearValidators();
        dataLimit?.clearValidators();
      }

      dataLimit?.updateValueAndValidity();
      usageLimit?.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public usageLimitsFormSubmit(): void {
    try {
      this.formSubmitted=true;

      if (!this.usageLimitsForm.valid) {
        return;
      }

      if (this.selectedLimitType===LimitType.Off) {
        this.possibleOrderUsageLimits={
          dataLimit                     : null,
          dataLimitCurrentDataWeightCode: null,
          dataLimitDataWeightCode       : null,
          limit                         : null,
          limitCurrent                  : null,
          limitSelfAuth                 : null,
          limitType                     : LimitType.Off
        };

      } else if (this.selectedLimitType===LimitType.Spend) {
        const spendLimit  : number | null=this.useCustomSpendLimit   ? this.usageLimitsForm.get("usageLimit")?.value    : null;
        const currentLimit: number | null=this.overrideCurrentMonth  ? this.usageLimitsForm.get("currentLimit")?.value  : null;
        const selfAuth    : number | null=this.showSelfAuthSpendLimit ? this.usageLimitsForm.get("selfAuthLimit")?.value : null;

        if (this.showSelfAuthSpendLimit && selfAuth != null && spendLimit != null &&
            parseInt(selfAuth.toString()) <= parseInt(spendLimit.toString())) {
          this.warningModalForm.openForm("Invalid Limits", "The <i>Self Authorisation Value</i> must be greater than the <i>Spend Limit</i>");
          return;
        }

        if (this.showSelfAuthSpendLimit && selfAuth != null && currentLimit != null &&
            parseInt(selfAuth.toString()) < parseInt(currentLimit.toString())) {
          this.warningModalForm.openForm("Invalid Limits", "The <i>Current Spend Limit</i> cannot be greater than the <i>Self Authorisation Value</i>");
          return;
        }

        this.possibleOrderUsageLimits={
          dataLimit                     : null,
          dataLimitCurrentDataWeightCode: null,
          dataLimitDataWeightCode       : null,
          limit                         : spendLimit,
          limitCurrent                  : currentLimit,
          limitSelfAuth                 : selfAuth,
          limitType                     : LimitType.Spend
        };

      } else if (this.selectedLimitType===LimitType.Data) {
        this.possibleOrderUsageLimits={
          dataLimit                     : this.useCustomDataLimit       ? this.usageLimitsForm.get("dataLimit")?.value        : null,
          dataLimitCurrent              : this.overrideCurrentMonthData ? this.usageLimitsForm.get("dataLimitCurrent")?.value : null,
          dataLimitCurrentDataWeightCode: this.overrideCurrentMonthData ? (this.usageLimitsForm.get("dataLimitCurrentUnit")?.value ?? "MB") : null,
          dataLimitDataWeightCode       : this.useCustomDataLimit       ? (this.usageLimitsForm.get("dataLimitUnit")?.value        ?? "MB") : null,
          limit                         : null,
          limitCurrent                  : null,
          limitSelfAuth                 : null,
          limitType                     : LimitType.Data
        };
      }

      if (this.currOrderUsageLimits?.dataLimit                      ==this.possibleOrderUsageLimits?.dataLimit                  &&
          this.currOrderUsageLimits?.dataLimitCurrent               ==this.possibleOrderUsageLimits?.dataLimitCurrent           &&
          this.currOrderUsageLimits?.dataLimitCurrentDataWeightCode ==this.possibleOrderUsageLimits?.dataLimitCurrentDataWeightCode &&
          this.currOrderUsageLimits?.dataLimitDataWeightCode        ==this.possibleOrderUsageLimits?.dataLimitDataWeightCode    &&
          this.currOrderUsageLimits?.limit                          ==this.possibleOrderUsageLimits?.limit                      &&
          this.currOrderUsageLimits?.limitCurrent                   ==this.possibleOrderUsageLimits?.limitCurrent               &&
          this.currOrderUsageLimits?.limitSelfAuth                  ==this.possibleOrderUsageLimits?.limitSelfAuth              &&
          this.currOrderUsageLimits?.limitType                      ==this.possibleOrderUsageLimits?.limitType) {
        this.beforeCloseAnimationLink="https://cdn.lordicon.com/rypcsrlk.json";
        this.beforeCloseWarningModalForm.openForm("Information", "No changes to the limits have been made");
      } else {
        if (this.dontShowSubmittedWarning==false) {
          this.beforeCloseAnimationLink="https://cdn.lordicon.com/tdrtiskw.json";
          this.beforeCloseWarningModalForm.openForm("Warning", "Limit changes will only be committed once the <i>Manage SIM</i> form has been submitted");
        } else {
          this.beforeCloseWarningModalFormIsClosed();
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public beforeCloseWarningModalFormIsClosed(): void {
    try {
      this.dataHasBeenSaved.emit(this.possibleOrderUsageLimits);
      this.usageLimitsModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public usageLimitsFormCancel(): void {
    try {
      this.usageLimitsFormCancelled.emit();
      this.usageLimitsModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getCompanyUsageLimitsAndOpenModal(): void {
    try {
      if (this.sureSimUser?.companyID==undefined || this.sureSimUser?.companyID<=0) {
        throw new Error("UsageLimitsModalFormComponent.getCompanyUsageLimitsAndOpenModal() - CompanyID cannot be determined");
      }

      this.companiesService.getById(this.sureSimUser?.companyID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        }),
        switchMap(companyData => {
          this.company=companyData;
          return this.companyUsageLimitsService.getForCompany(<number>this.sureSimUser?.companyID);
        }),
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next: data => {
          this.companyUsageLimits   =data;
          this.companySelfAuthLimit =this.companyUsageLimits.limitSelfAuth  ?? "";
          this.companyDataLimit     =this.companyUsageLimits.dataLimit      ?? "";
          this.companyDataWeightCode=this.companyUsageLimits.dataLimitDataWeightCode ?? "MB";
          this.companyUsageLimit    =this.companyUsageLimits.limit          ?? "";
          this.usageLimitsForm.controls["dataLimitUnit"].setValue(this.companyDataWeightCode);
          this.usageLimitsForm.controls["dataLimitCurrentUnit"].setValue(this.companyDataWeightCode);

          if (this.currentLimitHint==null || this.currentLimitHint==undefined) {
            this.currentLimitHint=<number>this.companyUsageLimit;
          }

          this.populateFormFields(this.usageLimitsForm);
          this.openModal();
        },
        error: error => {
          this.usageLimitsFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getSureSimOrderAndOpenModal(): void {
    try {
      this.ordersService.getById(this.sureSimOrderId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        }),
        switchMap((order: OrderDTO) => {
          this.sureSimOrder=order;
          return this.ordersService.getOrderUsageLimitsOrDefaults(this.sureSimOrderId);
        }),
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next: data => {
          this.currOrderUsageLimits=data;

          if (this.sureSimOrder!.limitCurrent != null && this.sureSimOrder!.limitCurrent != undefined) {
            this.currentLimitHint=this.sureSimOrder!.limitCurrent;
          } else {
            this.currentLimitHint=undefined;
          }

          this.getSureSimUserAndOpenModal();
        },
        error: error => {
          this.usageLimitsFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getSureSimUserAndOpenModal(): void {
    try {
      if (this.sureSimOrder?.userID==undefined || this.sureSimOrder?.userID<=0) {
        throw new Error("UsageLimitsModalFormComponent.getSureSimUserAndOpenModal() - UserID cannot be determined");
      }

      this.usersService.getById(this.sureSimOrder?.userID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
        })
      )
      .subscribe({
        next: data => {
          this.sureSimUser=data;
          this.getCompanyUsageLimitsAndOpenModal();
        },
        error: error => {
          this.usageLimitsFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
